/** Tiny observable app state; every page re-renders from here. */
import type { BookingPage, CalendarEvent, FocusSession, Meeting, Note, Preferences, ResearchItem, Task } from "./data/types";
import { defaultPreferences } from "./data/types";

export interface AppState {
  userName: string;
  userEmail: string;
  tasks: Task[];
  events: CalendarEvent[];
  meetings: Meeting[];
  notes: Note[];
  research: ResearchItem[];
  focusSessions: FocusSession[];
  bookingPage: BookingPage | null;
  prefs: Preferences;
  activeMeetingId: string | null;
  setup: { calendarConfigured: boolean; emailConfigured: boolean };
  /**
   * Which collections have answered at least once. Until one has, an empty list means "not here
   * yet", not "you have none" - and saying the second on a slow connection told people their
   * meetings were gone.
   */
  loaded: { tasks?: boolean; events?: boolean; meetings?: boolean };
}

export const state: AppState = { userName: "there", userEmail: "", tasks: [], events: [], meetings: [], notes: [], research: [], focusSessions: [], bookingPage: null, prefs: defaultPreferences(), activeMeetingId: null, setup: { calendarConfigured: false, emailConfigured: false }, loaded: {} };

const subs = new Set<() => void>();
export const subscribe = (fn: () => void) => { subs.add(fn); return () => subs.delete(fn); };
let scheduled = false;
export function notify() {
  if (scheduled) return;
  scheduled = true;
  queueMicrotask(() => { scheduled = false; subs.forEach((fn) => fn()); });
}
export function patch(p: Partial<AppState>) { Object.assign(state, p); notify(); }
